import { rankWith, scopeEndsWith } from '@jsonforms/core';

export const customLabelTextTester = rankWith(10, scopeEndsWith('value'));
